module.exports = __webpack_public_path__ + "img/Untitled design (2).639235f3.png";